import Vue from "vue";
import Vuex from "vuex";

import user from "./modules/user";
import auth from "./modules/auth";
import reported from "./modules/reported.module";
import permissions from "./modules/permissions.module";
import defectSolutions from "./modules/defectSolutions.module";
Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        user,
        auth,
        reported,
        defectSolutions,
        permissions
    }
});
